// extracted by mini-css-extract-plugin
export var card = "_l7-1";
export var summary = "_l7-0";